import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=4811a5f2&scoped=true&"
import script from "./Delete.vue?vue&type=script&lang=js&"
export * from "./Delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811a5f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4811a5f2')) {
      api.createRecord('4811a5f2', component.options)
    } else {
      api.reload('4811a5f2', component.options)
    }
    module.hot.accept("./Delete.vue?vue&type=template&id=4811a5f2&scoped=true&", function () {
      api.rerender('4811a5f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/table/item_actions/Delete.vue"
export default component.exports